import React from 'react'

import { ReactComponent as Pin } from '../../../assets/pin.svg'
import { ReactComponent as PinLarge } from '../../../assets/pin-large.svg'
import { COLORS } from '../../../constants/colors'
import { JobCard } from '../JobCard'

import { StyledMarker, StyledPopup } from './styles'

const JobPinView = ({
  job,
  isDeleting,
  isHovered,
  isSelected,
  color,
  onSelectJob,
  onClosePopup,
}) => {
  const highlighted = isDeleting || isSelected || isHovered
  // Put the pin's tip (bottom-centre) on the job location. pin-large.svg renders
  // at 26x36; pin.svg renders 16x26 with its 26:36 artwork letterboxed, so its tip
  // is at (8, ~24). Any error here is in pixels, so it grows on the ground as the
  // map zooms out and the pin appears to drift off its location.
  const offsetTop = highlighted ? -36 : -24
  const offsetLeft = highlighted ? -13 : -8
  const pinColor = color || COLORS.PIN.GREEN

  function handleSelectJob(...args) {
    if (isSelected) {
      return
    }

    onSelectJob(...args)
  }

  return (
    <div>
      {(isSelected || isDeleting) && (
        <StyledPopup
          latitude={job.addressLocation.coordinates[1]}
          longitude={job.addressLocation.coordinates[0]}
          offsetTop={-41}
          offsetLeft={0}
          closeButton
          closeOnClick={false}
          onClose={onClosePopup}
          anchor="bottom"
        >
          <JobCard
            index={0}
            disabled={false}
            sortDisabled={false}
            cols={1}
            spacing={10}
            job={job}
            isCard={false}
          />
        </StyledPopup>
      )}
      <StyledMarker
        key={job.id}
        latitude={job.addressLocation.coordinates[1]}
        longitude={job.addressLocation.coordinates[0]}
        offsetLeft={offsetLeft}
        offsetTop={offsetTop}
        selected={isSelected}
      >
        {highlighted ? (
          <PinLarge fill={pinColor} onClick={handleSelectJob} />
        ) : (
          <Pin fill={pinColor} onClick={handleSelectJob} />
        )}
      </StyledMarker>
    </div>
  )
}

export { JobPinView }
